import { render, staticRenderFns } from "./InformativaCaregivers.vue?vue&type=template&id=13f05f02&"
import script from "./InformativaCaregivers.vue?vue&type=script&lang=js&"
export * from "./InformativaCaregivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports